// extracted by mini-css-extract-plugin
export default {"link":"SimpleEntityWidget_link__6kqCI"};